/* Just Catnip basket drawer: the play-set upsell (option A).
   The upsell card in snippets/cart-drawer.liquid is a normal Dawn product-form
   whose <form> carries data-jc-upsell-code. Before Dawn's add runs we apply that
   discount code to the cart (/cart/update.js {discount}), so the line arrives at
   the offer price in one render. When the upsell product later leaves the basket
   we clear the code again, so a later full-price add is not silently discounted.
   Prices are never touched here: Shopify applies the code and the drawer shows
   whatever the cart holds. */
(function () {
  'use strict';
  var KEY = 'jc-upsell-code-applied';

  function post(url, body) {
    var config = typeof fetchConfig === 'function' ? fetchConfig() : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    config.body = JSON.stringify(body);
    return fetch(url, config).then(function (r) { return r.json(); });
  }
  function hasCode(cart, code) {
    return !!(cart && cart.discount_codes && cart.discount_codes.some(function (d) { return String(d.code).toUpperCase() === code.toUpperCase(); }));
  }
  function remember(v) { try { v ? sessionStorage.setItem(KEY, v) : sessionStorage.removeItem(KEY); } catch (e) {} }
  function remembered() { try { return sessionStorage.getItem(KEY); } catch (e) { return null; } }

  /* 1. Apply the code, then hand the submit back to Dawn's product-form. */
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form[data-jc-upsell-code]') : null;
    if (!form || form.dataset.jcCodeReady === '1') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var code = form.dataset.jcUpsellCode;
    var pf = form.closest('product-form');
    var btn = form.querySelector('[type="submit"]');
    var spinner = form.querySelector('.loading__spinner');
    var errWrap = pf && pf.querySelector('.product-form__error-message-wrapper');
    var errText = errWrap && errWrap.querySelector('.product-form__error-message');
    if (btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');
    if (spinner) spinner.classList.remove('hidden');
    if (errWrap) errWrap.hidden = true;

    post(window.routes.cart_update_url, { discount: code })
      .then(function (cart) {
        if (!hasCode(cart, code)) throw new Error('code not accepted');
        remember(code);
        form.dataset.jcCodeReady = '1';
        btn.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
        if (typeof form.requestSubmit === 'function') form.requestSubmit(btn);
        else btn.click();
      })
      .catch(function () {
        btn.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
        if (errWrap && errText) {
          errText.textContent = (window.cartStrings && window.cartStrings.jcUpsellError) || 'We couldn\'t apply the offer. Please try again.';
          errWrap.hidden = false;
        }
      });
  }, true);

  /* 2. Drop the code once the upsell product is no longer in the basket. */
  function upsellProductId() {
    var el = document.querySelector('cart-drawer[data-jc-upsell-product]');
    return el ? String(el.dataset.jcUpsellProduct) : null;
  }
  function maybeClear() {
    var code = remembered();
    var pid = upsellProductId();
    if (!code || !pid) return;
    /* Dawn declares CartItems / PUB_SUB_EVENTS with class / const, so they are globals but not window properties. */
    var fetchCart = (typeof CartItems !== 'undefined' && typeof CartItems.fetchCartData === 'function')
      ? CartItems.fetchCartData()
      : fetch(window.routes.cart_url + '.json').then(function (r) { return r.json(); });
    fetchCart.then(function (cart) {
      if (!cart || !cart.items) return;
      var still = cart.items.some(function (i) { return String(i.product_id) === pid; });
      if (still) return;
      remember('');
      if (hasCode(cart, code)) return post(window.routes.cart_update_url, { discount: '' });
    }).catch(function () {});
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(maybeClear, 0); });
  }

  /* 3. Images inside the re-rendered drawer: WebKit can leave images injected into a
     fixed, initially hidden container unloaded. After every drawer re-render, restart
     any image that has not loaded by re-assigning its own src. */
  function nudgeImages(root) {
    root.querySelectorAll('img').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) return;
      var src = img.getAttribute('src');
      if (!src) return;
      img.removeAttribute('src');
      img.setAttribute('src', src);
    });
  }
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.jcImgWatch) return;
    drawer.dataset.jcImgWatch = '1';
    var pending;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () { nudgeImages(drawer); }, 50);
    }).observe(drawer, { childList: true, subtree: true });
    drawer.addEventListener('transitionend', function () { nudgeImages(drawer); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer);
  else watchDrawer();
})();
